import { render, staticRenderFns } from "./PrimaryColumnTemplate.vue?vue&type=template&id=3d0c1d7e&"
import script from "./PrimaryColumnTemplate.vue?vue&type=script&lang=js&"
export * from "./PrimaryColumnTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports